<template>
    <div class="container">
        <div class="data-swiper">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <swiper-slide>
                    <div class="item">
                        <div class="txt">
                            <p>案例发布数据</p>
                            <p>统计截止时间：{{ dataObj.case.release.date }}</p>
                        </div>
                        <div class="data-box">
                            <div class="data">
                                <p class="val">{{ dataObj.case.release.today }}</p>
                                <p class="key">今日新增</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.release.month }}</p>
                                <p class="key">本月新增</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.release.total }}</p>
                                <p class="key">累计案例</p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="item">
                        <div class="txt">
                            <p>案例转发数据</p>
                            <p>统计截止时间：{{ dataObj.case.forward.date }}</p>
                        </div>
                        <div class="data-box">
                            <div class="data">
                                <p class="val">{{ dataObj.case.forward.today }}</p>
                                <p class="key">今日转发</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.forward.month }}</p>
                                <p class="key">本月转发</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.forward.total }}</p>
                                <p class="key">累计转发</p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="item">
                        <div class="txt">
                            <p>案例类别数据</p>
                            <p>统计截止时间：{{ dataObj.case.category.date }}</p>
                        </div>
                        <div class="data-box">
                            <div class="data">
                                <p class="val">{{ dataObj.case.category.praise }}</p>
                                <p class="key">累计口碑案例</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.category.video }}</p>
                                <p class="key">累计视频案例</p>
                            </div>
                            <div class="data">
                                <p class="val">{{ dataObj.case.category.suit }}</p>
                                <p class="key">累计套购案例</p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>

        <div class="tab-box">
            <router-link :to="'/user/analysis/detail?type=user_id'" tag="div" class="item">
                <p class="key">直销员排名</p>
                <div class="icon">
                    <img src="../../../assets/images/user/analysis/icon_tab1.png" />
                </div>
                <p class="val">参与人数{{ dataObj.rank.sales }}人</p>
            </router-link>
            <router-link :to="'/user/analysis/detail?type=office'" tag="div" class="item">
                <p class="key">办事处排名</p>
                <div class="icon">
                    <img src="../../../assets/images/user/analysis/icon_tab2.png" />
                </div>
                <p class="val">参与办事处{{ dataObj.rank.office }}个</p>
            </router-link>
            <router-link :to="'/user/analysis/detail?type=city'" tag="div" class="item">
                <p class="key">城市排名</p>
                <div class="icon">
                    <img src="../../../assets/images/user/analysis/icon_tab3.png" />
                </div>
                <p class="val">参与城市{{ dataObj.rank.city }}个</p>
            </router-link>
            <!-- <div
        class="item"
        :class="{ active: tab == 'user_id' }"
        @click="setTab('user_id')"
      >
        <p class="key">直销员排名</p>
        <div class="icon">
          <img src="../../../assets/images/user/analysis/icon_tab1.png" />
        </div>
        <p class="val">参与人数{{ dataObj.rank.sales }}人</p>
      </div>
      <div
        class="item"
        :class="{ active: tab == 'office' }"
        @click="setTab('office')"
      >
        <p class="key">办事处排名</p>
        <div class="icon">
          <img src="../../../assets/images/user/analysis/icon_tab2.png" />
        </div>
        <p class="val">参与办事处{{ dataObj.rank.office }}个</p>
      </div>
      <div
        class="item"
        :class="{ active: tab == 'city' }"
        @click="setTab('city')"
      >
        <p class="key">城市排名</p>
        <div class="icon">
          <img src="../../../assets/images/user/analysis/icon_tab3.png" />
        </div>
        <p class="val">参与城市{{ dataObj.rank.city }}个</p>
      </div> -->
        </div>
        <!-- <div class="line">
      <chartLine ref="chart_line_one"></chartLine>
    </div> -->
        <div id="releaseVolume" class="release-volume" :style="{ height: '300px'}"></div>
        <div id="forwardingVolume" class="forwarding-volume" :style="{ height: '300px'}"></div>

        <!-- <div class="rank-list">
      <div class="rank-tt">
        <p v-if="tab == 'user_id'">直销员姓名</p>
        <p v-if="tab == 'office'">办事处</p>
        <p v-if="tab == 'city'">城市</p>
        <p>视频案例</p>
        <p>口碑案例</p>
        <p>套购案例</p>
        <p>全部案例</p>
      </div>
      <div class="rank-main">
        <div class="item" v-for="(item, index) in pageData.rank">
          <p>{{ item.name }}</p>
          <p>{{ item.video }}</p>
          <p>{{ item.praise }}</p>
          <p>{{ item.suit }}</p>
          <p>{{ item.total }}</p>
          <p class="sort">{{ index + 1 }}</p>
        </div>
      </div>
      <p class="tips">*以上为人员本月全部案例转发量排名</p>
    </div> -->
        <!-- <router-link
      :to="'/user/analysis/detail?type=' + tab"
      tag="div"
      class="view-all"
      >更多数据明细 ></router-link
    > -->
        <!-- 荣耀榜 -->
        <div class="glory-list">
            <h3>本月荣誉榜</h3>
            <div class="list">
                <div class="item" v-if="pageData.honor.forward">
                    <div class="headimg">
                        <img :src="
                pageData.honor.forward ? pageData.honor.forward.img : ''
              " />
                    </div>
                    <p class="name">{{ pageData.honor.forward.name }}</p>
                    <p class="area">{{ pageData.honor.forward.area }}</p>
                    <p class="push">
                        本月转发<span class="num">{{ pageData.honor.forward.num }}</span>次
                    </p>
                </div>
                <div class="item" v-if="pageData.honor.release">
                    <div class="headimg">
                        <img :src="
                pageData.honor.release ? pageData.honor.release.img : ''
              " />
                    </div>
                    <p class="name">{{ pageData.honor.release.name }}</p>
                    <p class="area">{{ pageData.honor.release.area }}</p>
                    <p class="push">
                        本月发布<span class="num">{{ pageData.honor.release.num }}</span>次
                    </p>
                </div>
                <div class="item" v-if="pageData.strive.forward">
                    <div class="headimg">
                        <img :src="
                pageData.strive.forward ? pageData.strive.forward.img : ''
              " />
                    </div>
                    <p class="name">{{ pageData.strive.forward.name }}</p>
                    <p class="area">{{ pageData.strive.forward.area }}</p>
                    <p class="push">
                        本月转发<span class="num">{{ pageData.strive.forward.num }}</span>次
                    </p>
                </div>
                <div class="item" v-if="pageData.strive.release">
                    <div class="headimg">
                        <img :src="pageData.strive.release.img" />
                    </div>
                    <p class="name">{{ pageData.strive.release.name }}</p>
                    <p class="area">{{ pageData.strive.release.area }}</p>
                    <p class="push">
                        本月发布<span class="num">{{ pageData.strive.release.num }}</span>次
                    </p>
                </div>
            </div>
        </div>
        <!-- <div class="strive-list">
      <h3>本月再接再厉榜</h3>
      <div class="list">
        <div class="item" v-for="item in pageData.strive.forward">
          <div class="headimg">
            <img :src="item.img" />
          </div>
          <p class="name">{{ item.name }}</p>
          <p class="area">{{ item.area }}</p>
          <p class="push">
            本月转发<span>{{ item.num || 0 }}</span
            >次
          </p>
        </div>
        <div class="item" v-for="item in pageData.strive.release">
          <div class="headimg">
            <img :src="item.img" />
          </div>
          <p class="name">{{ item.name }}</p>
          <p class="area">{{ item.area }}</p>
          <p class="push">
            本月发布<span>{{ item.num || 0 }}</span
            >次
          </p>
        </div>
      </div>
    </div> -->

        <div class="case-list">
            <h3>最受欢迎的案例</h3>
            <div class="list">
                <div class="item" v-for="item in proList" @click="toDetail(item)">
                    <div class="img">
                        <img :src="item.img" />
                    </div>
                    <p class="name">{{ item.name }}</p>
                    <p class="area">·{{ item.category }}</p>
                    <p class="push">
                        被转发<span>{{ item.num }}</span>次
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import path from "@/path.js";
import * as echarts from "echarts";
export default {
    data() {
        return {
            name: "转发量",
            xData: ["6/15", "6/16", "6/17", "6/18", "6/19", "6/20", "6/21"],
            yData: [30, 132, 80, 134, 134, 134, 134],
            swiperOption: {
                pagination: {
                    el: ".swiper-pagination",
                },
            },
            tab: "user_id",
            dataObj: {
                case: { release: {}, forward: {}, category: {} },
                rank: {},
            },
            pageData: {
                honor: { forward: [{}, {}], release: [{}, {}] },
                rank: [],
                strive: {
                    forward: [],
                    release: [],
                },
            },
            proList: [],
        };
    },
    created() {
        path.post5(path.praiseIndex).then((res) => {
            //  console.log(res);
            if (res.data.error == 0) {
                this.dataObj = res.data.data.result;
            }
        });
        this.praiseRank();
        path.post5(path.praiseGoods).then((res) => {
            if (res.data.error == 0) {
                this.proList = res.data.data.result;
            }
        });
    },
    mounted() {
        const { name, xData, yData } = this;
        this.drawLine();
        // this.$refs.chart_line_one.initChart(name, xData, yData);
    },
    methods: {
        // 获取制作图表
        drawLine() {
            let forwardingVolume = echarts.init(
                document.getElementById("forwardingVolume")
            );
            let releaseVolume = echarts.init(
                document.getElementById("releaseVolume")
            );
            const xAxisData = new Array(7);
            for (let i = 0; i < 7; i++) {
                const date = new Date(
                    new Date().getTime() - 1000 * 60 * 60 * 24 * i
                );
                const Month = date.getMonth() + 1;
                const Day = date.getDate();
                xAxisData[7 - 1 - i] = `${Month < 10 ? "0" + Month : Month}.${
                    Day < 10 ? "0" + Day : Day
                }`;
            }
            path.post5(path.praiseIndexViews).then((res) => {
                if (res.data.error == 0) {
                    const seriesData = [];
                    const result = res.data.data.result;
                    for (const key in res.data.data.result) {
                        seriesData.push(result[key].num || 0);
                    }
                    forwardingVolume.setOption({
                        title: {
                            text: "案例每日转发量",
                        },
                        tooltip: {},
                        xAxis: {
                            type: "category",
                            data: xAxisData,
                            axisLabel: {
                                interval: 0,
                                rotate: 40,
                            },
                            axisTick: {
                                alignWithLabel: true,
                            },
                        },
                        yAxis: {
                            type: "value",
                        },
                        series: [
                            {
                                data: seriesData,
                                type: "line",
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true,
                                        },
                                    },
                                },
                            },
                        ],
                    });
                }
            });
            path.post5(path.praiseIndexBroken).then((res) => {
                if (res.data.error == 0) {
                    const seriesData = [];
                    const result = res.data.data.result;
                    for (const key in res.data.data.result) {
                        seriesData.push(result[key].num || 0);
                    }
                    releaseVolume.setOption({
                        title: { text: "案例每日发布量" },
                        tooltip: {},
                        xAxis: {
                            type: "category",
                            data: xAxisData,
                            axisLabel: {
                                interval: 0,
                                rotate: 40,
                            },
                            axisTick: {
                                alignWithLabel: true,
                            },
                        },
                        yAxis: {
                            type: "value",
                        },
                        series: [
                            {
                                data: seriesData,
                                type: "line",
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true,
                                        },
                                    },
                                },
                            },
                        ],
                    });
                }
            });
        },
        toDetail(item) {
            wx.miniProgram.navigateTo({
                url: `/pages/case/case_detail_vue/index?topicid=${item.id}&userid=${this.$route.query.userid}`,
            });
        },
        // setTab(val) {
        //   if (this.tab != val) {
        //     this.tab = val;
        //     this.praiseRank();
        //   }
        // },
        praiseRank() {
            path.post5(path.praiseRank, { type: this.tab }).then((res) => {
                if (res.data.error == 0) {
                    this.pageData = res.data.data.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.swiper-pagination {
    .swiper-pagination-bullet {
        background: #6d7278;
        width: 16px;
        height: 10px;
        border-radius: 10px;
    }
    .swiper-pagination-bullet-active {
        background: #003c8c;
        width: 25px;
    }
}
</style>
<style lang="scss" scoped>
@import "./report";
.forwarding-volume,
.release-volume {
    background: #fff;
    padding: 40px 0 0 20px;
    margin: 40px;
    box-sizing: border-box;
    border-radius: 10px;
}

.glory-list {
    h3 {
        color: #000000;
    }
    .list {
        .item {
            color: #000000;
            .name {
                height: 50px;
                font-size: 32px;
            }
            // .area {
            //   font-size: 24px !important;
            // }
            .push {
                .num {
                    color: #003c8c;
                    font-weight: bold;
                    margin: 0 2px;
                }
            }
            &:nth-child(3),
            &:nth-child(4) {
                margin-top: 60px;
            }
        }
    }
}
</style>
